module.exports = __webpack_public_path__ + "img/ca83856.png";